"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseProfileCompletenessDto = instanceOfNurseProfileCompletenessDto;
exports.NurseProfileCompletenessDtoFromJSON = NurseProfileCompletenessDtoFromJSON;
exports.NurseProfileCompletenessDtoFromJSONTyped = NurseProfileCompletenessDtoFromJSONTyped;
exports.NurseProfileCompletenessDtoToJSON = NurseProfileCompletenessDtoToJSON;
exports.NurseProfileCompletenessDtoToJSONTyped = NurseProfileCompletenessDtoToJSONTyped;
const RegulatoryAssessmentGroupStatus_1 = require("./RegulatoryAssessmentGroupStatus");
/**
 * Check if a given object implements the NurseProfileCompletenessDto interface.
 */
function instanceOfNurseProfileCompletenessDto(value) {
    return true;
}
function NurseProfileCompletenessDtoFromJSON(json) {
    return NurseProfileCompletenessDtoFromJSONTyped(json, false);
}
function NurseProfileCompletenessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'generalBackgroundCheck': json['generalBackgroundCheck'] == null ? undefined : json['generalBackgroundCheck'],
        'supplementalBackgroundChecks': json['supplementalBackgroundChecks'] == null ? undefined : json['supplementalBackgroundChecks'],
        'contract': json['contract'] == null ? undefined : json['contract'],
        'confidentialityAgreement': json['confidentialityAgreement'] == null ? undefined : json['confidentialityAgreement'],
        'dhsBackgroundCheck': json['dhsBackgroundCheck'] == null ? undefined : json['dhsBackgroundCheck'],
        'emrSystems': json['emrSystems'] == null ? undefined : json['emrSystems'],
        'i9Form': json['i9Form'] == null ? undefined : json['i9Form'],
        'tuberculosis': json['tuberculosis'] == null ? undefined : json['tuberculosis'],
        'personalInformation': json['personalInformation'] == null ? undefined : json['personalInformation'],
        'shiftPreferences': json['shiftPreferences'] == null ? undefined : json['shiftPreferences'],
        'specialties': json['specialties'] == null ? undefined : json['specialties'],
        'regulatoryAssessments': json['regulatoryAssessments'] == null ? undefined : json['regulatoryAssessments'],
        'regulatoryAssessmentsStatus': json['regulatoryAssessmentsStatus'] == null ? undefined : (0, RegulatoryAssessmentGroupStatus_1.RegulatoryAssessmentGroupStatusFromJSON)(json['regulatoryAssessmentsStatus']),
        'licenses': json['licenses'] == null ? undefined : json['licenses'],
        'vaccinations': json['vaccinations'] == null ? undefined : json['vaccinations'],
        'certifications': json['certifications'] == null ? undefined : json['certifications'],
        'certificationsVerified': json['certificationsVerified'] == null ? undefined : json['certificationsVerified'],
        'payroll': json['payroll'] == null ? undefined : json['payroll'],
        'resume': json['resume'] == null ? undefined : json['resume'],
    };
}
function NurseProfileCompletenessDtoToJSON(json) {
    return NurseProfileCompletenessDtoToJSONTyped(json, false);
}
function NurseProfileCompletenessDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'generalBackgroundCheck': value['generalBackgroundCheck'],
        'supplementalBackgroundChecks': value['supplementalBackgroundChecks'],
        'contract': value['contract'],
        'confidentialityAgreement': value['confidentialityAgreement'],
        'dhsBackgroundCheck': value['dhsBackgroundCheck'],
        'emrSystems': value['emrSystems'],
        'i9Form': value['i9Form'],
        'tuberculosis': value['tuberculosis'],
        'personalInformation': value['personalInformation'],
        'shiftPreferences': value['shiftPreferences'],
        'specialties': value['specialties'],
        'regulatoryAssessments': value['regulatoryAssessments'],
        'regulatoryAssessmentsStatus': (0, RegulatoryAssessmentGroupStatus_1.RegulatoryAssessmentGroupStatusToJSON)(value['regulatoryAssessmentsStatus']),
        'licenses': value['licenses'],
        'vaccinations': value['vaccinations'],
        'certifications': value['certifications'],
        'certificationsVerified': value['certificationsVerified'],
        'payroll': value['payroll'],
        'resume': value['resume'],
    };
}
//# sourceMappingURL=NurseProfileCompletenessDto.js.map